import { render, staticRenderFns } from "./MakeVote.vue?vue&type=template&id=2977bc2d&scoped=true&"
import script from "./MakeVote.vue?vue&type=script&lang=ts&"
export * from "./MakeVote.vue?vue&type=script&lang=ts&"
import style0 from "./MakeVote.vue?vue&type=style&index=0&id=2977bc2d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2977bc2d",
  null
  
)

export default component.exports